import { buttonWidgetModel } from '@web/widgets/button/model/button.model';
import { imageWidgetModel } from '@web/widgets/image/model/image.model';
import { galleryWidgetModel } from '@web/widgets/gallery/model/gallery.model';
import { lineWidgetModel } from '@web/widgets/line/model/line.model';
import { indentWidgetModel } from '@web/widgets/indent/model/indent.model';
import { textWidgetModel } from '@web/widgets/text/model/text.model';
import { videoWidgetModel } from '@web/widgets/video/model/video.model';
import { formWidgetModel } from '@web/widgets/form/model/form.model';
import { paymentFormWidgetModel } from '@web/widgets/payment-form/model/payment-form.model';
import { chatBotWidgetModel } from '@web/widgets/chat-bot/model/chat-bot.model';
import { socialWidgetModel } from '@web/widgets/social/model/social.model';
import { menuWidgetModel } from '@web/widgets/menu/model/menu.model';
import { mapWidgetModel } from '@web/widgets/map/model/map.model';
import { accordionWidgetModel } from '@web/widgets/accordion/model/accordion.model';
import { timerWidgetModel } from '@web/widgets/timer/model/timer.model';
import { loginEduWidgetModel } from '@web/widgets/login-edu/model/login-edu.model';
import { eduLoginButtonWidgetModel } from '@web/widgets/edu-login-button/model/edu-login-button.model';
import { codeWidgetModel } from '@web/widgets/code/model/code.model';
import { testimonialWidgetModel } from '@web/widgets/testimonial/model/testimonial.model';
import { navigationWidgetModel } from '@web/widgets/navigation/model/navigation.model';
import { logoWidgetModel } from '@web/widgets/logo/model/logo.model';
import { productCardWidgetModel } from '@web/widgets/product-card/model/product-card.model';
import { shopCartWidgetModel } from '@web/widgets/shop-cart/model/shop-cart.model';
import { shopCartIconWidgetModel } from '@web/widgets/shop-cart-icon/model/shop-cart-icon.model';
import { beforeAfterWidgetModel } from '@web/widgets/before-after/model/before-after.model';
import { figureWidgetModel } from '@web/widgets/figure/model/figure.model';
import { catalogProductsWidgetModel } from '@web/widgets/catalog-products/model/catalog-products.model';

export default [
    buttonWidgetModel,
    imageWidgetModel,
    galleryWidgetModel,
    lineWidgetModel,
    indentWidgetModel,
    textWidgetModel,
    videoWidgetModel,
    formWidgetModel,
    paymentFormWidgetModel,
    chatBotWidgetModel,
    socialWidgetModel,
    menuWidgetModel,
    mapWidgetModel,
    accordionWidgetModel,
    timerWidgetModel,
    loginEduWidgetModel,
    eduLoginButtonWidgetModel,
    codeWidgetModel,
    testimonialWidgetModel,
    navigationWidgetModel,
    logoWidgetModel,
    productCardWidgetModel,
    shopCartWidgetModel,
    shopCartIconWidgetModel,
    beforeAfterWidgetModel,
    figureWidgetModel,
    catalogProductsWidgetModel,
];
